/*
 *  Copyright 2012-2013 (c) Pierre Duquesne <stackp@online.fr>
 *  Licensed under the New BSD License.
 *  https://github.com/stackp/promisejs
 */

/* eslint-disable */

export function Promise() {
    this._callbacks = [];
    this._isdone = false;
    this.result = [];
}

// Может быть поддерживать вызов then без callback?
Promise.prototype.then = function(callback, context) {
    const p = new Promise();

    function resolve() {
        const result = callback?.apply(context, arguments);
        if (result instanceof Promise) {
            result.then(p.done, p);
        } else {
            p.done(result);
        }
    }

    this._isdone
        ? resolve.apply(null, this.result)
        : this._callbacks.push(resolve);

    return p;
};

Promise.prototype.done = function() {
    this.result = arguments;
    this._isdone = true;
    for (let i = 0; i < this._callbacks.length; i++) {
        this._callbacks[i].apply(null, this.result);
    }
    this._callbacks.length = 0;
    // Ошибся! Возврат this приводит к зацикливанию цепочки then!
    // return this;
};

Promise.join = function(promises) {
    const p = new Promise();
    const results = [];
    let resolved = 0;

    promises && promises.length > 0
        ? promises.forEach(notify)
        : p.done(results);

    function notify(pp, i, ps) {
        pp.then(function() {
            resolved++;
            results[i] = Array.prototype.slice.call(arguments);
            if (resolved == ps.length) {
                p.done(results);
            }
        });
    }
    return p;
};

Promise.chain = function(callbacks, args) {
    const p = new Promise();
    if (callbacks && callbacks.length) {
        callbacks[0].apply(null, args).then(function(error, result) {
            Promise.chain(callbacks.slice(1), arguments).then(function() {
                p.done.apply(p, arguments);
            });
        });
    } else {
        p.done.apply(p, args);
    }
    return p;
};

/*
 * AJAX requests
 */

function newXhr() {
    let xhr;
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else if (window.ActiveXObject) {
        try {
            xhr = new ActiveXObject('Msxml2.XMLHTTP');
        } catch (e) {
            xhr = new ActiveXObject('Microsoft.XMLHTTP');
        }
    }
    return xhr;
}

/**
 * @param {*} data                 - данные запроса
 * @param {boolean} [spreadArrays] - раскладывать ли параметры-массивы на отдельные параметры
 *                                   действует только для кодировки по умолчанию
 * @param {string} [type]          - кодировка данных, по умолчанию "application/x-www-form-urlencoded"
 */
function encode(
    data,
    spreadArrays = false,
    type = 'application/x-www-form-urlencoded'
) {
    if (data instanceof FormData) {
        return data;
    }
    if (typeof data != 'object' || data === null) {
        return data || '';
    }
    switch (type) {
        case 'application/json':
            return JSON.stringify(data);

        case 'text/plain':
            return Object.keys(data)
                .map(function(name) {
                    return `${name}=${data[name]}`;
                })
                .join('\r\n');

        default:
            return Object.keys(data)
                .reduce((query, name) => {
                    const value = data[name];
                    // Если spreadArrays = true, параметры с литералом массива в конце названия
                    // раскладываются на отдельные значения из названий которых литерал массива [] удаляется
                    if (
                        name.slice(-2) == '[]' &&
                        Array.isArray(value) &&
                        spreadArrays
                    ) {
                        return query.concat(
                            value.map(v => [name.slice(0, -2), v])
                        );
                    } else {
                        return query.push([name, value]), query;
                    }
                }, [])
                .map(
                    param =>
                        `${encodeURIComponent(param[0])}=${encodeURIComponent(
                            param[1]
                        )}`
                )
                .join('&');
    }
}

function ajax(method, url, data, headers, settings) {
    const p = new Promise();
    let xhr;
    let payload = null;

    try {
        xhr = newXhr();
    } catch (e) {
        p.done(promise.ENOXHR, '');
        return p;
    }

    const supportedTypes = [
        'application/x-www-form-urlencoded',
        'application/json',
        'text/plain'
    ];

    const contentType =
        (headers &&
            headers[
                Object.keys(headers).filter(function(h) {
                    return h.toLowerCase() == 'content-type';
                })[0]
            ]) ||
        supportedTypes[0];

    if (method.toUpperCase() == 'GET') {
        xhr.open(method, url + (data ? `?${encode(data, true)}` : ''));
        xhr.setRequestHeader(
            'Content-type',
            'application/x-www-form-urlencoded'
        );
    } else if (data instanceof FormData) {
        xhr.open(method, url);
        payload = data;
    } else {
        xhr.open(method, url);
        xhr.setRequestHeader('Content-type', contentType);
        payload = encode(
            data,
            false,
            supportedTypes.filter(function(type) {
                return contentType.match(new RegExp(type, 'i'));
            })[0]
        );
    }

    for (const h in headers) {
        if (headers.hasOwnProperty(h) && h.toLowerCase() != 'content-type') {
            xhr.setRequestHeader(h, headers[h]);
        }
    }

    for (const s in settings) {
        xhr[s] = settings[s];
    }

    function onTimeout() {
        xhr.abort();
        p.done(promise.ETIMEOUT, '', xhr);
    }

    const timeout = promise.ajaxTimeout;
    if (timeout) {
        var tid = setTimeout(onTimeout, timeout);
    }

    xhr.onreadystatechange = function() {
        if (timeout) {
            clearTimeout(tid);
        }
        if (xhr.readyState == 4) {
            const err =
                !xhr.status ||
                ((xhr.status < 200 || xhr.status >= 300) && xhr.status !== 304);
            p.done(err, xhr.responseText, xhr);
        }
    };

    xhr.send(payload);
    return p;
}

function ajaxer(method) {
    return function(url, data, headers, settings) {
        return ajax(method, url, data, headers, settings);
    };
}

const promise = {
    Promise,
    join: Promise.join,
    chain: Promise.chain,
    ajax,
    encode,
    get: ajaxer('GET'),
    post: ajaxer('POST'),
    put: ajaxer('PUT'),
    patch: ajaxer('PATCH'),
    delete: ajaxer('DELETE'),

    /* Error codes */
    ENOXHR: 1,
    ETIMEOUT: 2,

    /**
     * Configuration parameter: time in milliseconds after which a
     * pending AJAX request is considered unresponsive and is
     * aborted. Useful to deal with bad connectivity (e.g. on a
     * mobile network). A 0 value disables AJAX timeouts.
     *
     * Aborted requests resolve the promise with a ETIMEOUT error
     * code.
     */
    ajaxTimeout: 0
};

export default promise;
